
export class PopSubtituloInsert {
  public texto: string;
  public idPai: number;

  constructor(texto: string, idPai: number ) {
    this.texto = texto;
    this.idPai = idPai;
  }
}